'use strict'
const Password = {
    init: function () {
        let password = document.querySelector('.password');
        if (password) {
            let elementFocusSkippedNotInPassword = document.querySelectorAll("a, button, input, textarea, select");
            elementFocusSkippedNotInPassword.forEach((el) => {
                if (!password.contains(el)) {
                    el.setAttribute('tabindex', '-1');
                }
            });

            if(password.querySelector(".password__error")){
                password.classList.add("has-error");
            }
        }
    }
}

export default Password;
